import { Joyride, type EventData } from "react-joyride";
import { TourTooltip } from "./TourTooltip";
import type { TourStep } from "@/lib/product-tour/tour-steps";

type Props = {
  steps: TourStep[];
  run: boolean;
  stepIndex: number;
  onEvent: (data: EventData) => void;
};

export function ProductTour({ steps, run, stepIndex, onEvent }: Props) {
  if (steps.length === 0) return null;

  return (
    <Joyride
      steps={steps}
      run={run}
      stepIndex={stepIndex}
      continuous
      tooltipComponent={TourTooltip}
      locale={{
        back: "Voltar",
        close: "Fechar",
        last: "Concluir",
        next: "Próximo",
        nextWithProgress: "Próximo ({current} de {total})",
        skip: "Pular tour",
      }}
      options={{
        buttons: ["back", "skip", "primary"],
        // Default do Joyride pro X é 'close', que significa "avança pro próximo passo" — quem fecha
        // quer sair, não avançar. 'skip' encerra o tour de vez (e cai no STATUS.SKIPPED que o
        // handleEvent já trata). O ESC não tem opção equivalente ('skip' não é aceito em
        // `dismissKeyAction`), então ele é tratado pelo ramo de ACTIONS.CLOSE do handleEvent.
        closeButtonAction: "skip",
        overlayClickAction: false,
        overlayColor: "rgba(24, 24, 27, 0.55)",
        primaryColor: "#2457ff",
        showProgress: true,
        // Destaque com folga e cantos do mesmo raio dos itens: sem isso ele cortava o rótulo do
        // grupo do menu ("GESTÃO") e encostava no texto.
        spotlightPadding: 6,
        spotlightRadius: 10,
        offset: 14,
        // Todo alvo do tour já fica visível sem rolar (perto do topo de cada rota) — deixar o
        // Joyride rolar sozinho causava o spotlight (o "buraco" do overlay) ficar preso na posição
        // de antes da rolagem, atrás do Topbar fixo (achado real, reportado em teste manual).
        skipScroll: true,
        zIndex: 9999,
      }}
      onEvent={(data) => onEvent(data)}
    />
  );
}
